import axios from "axios";
import storage from "./storage";
import {ENTRYPOINT} from "../config/entrypoint";

const SITE_STORAGE_KEY = 'site';

export function getCurrentSiteDetails() {
  return new Promise((resolve, reject) => {
    /* get from local storage if it's stored less than one day */
    let currentSite = getCurrentSiteDetailsFromStorage();
    if (
      currentSite &&
      currentSite.name !== undefined && //Need to check that it's valid object in locatstorage-expires format
      currentSite.status !== 'inactive'
    ) {
        return resolve(currentSite);
    }

    fetchCurrentSiteDetailsFromApi().then(siteDetails => {
      storeCurrentSiteDetails(siteDetails);
      return resolve(siteDetails);
    }).catch(error => reject(error));
  });
}

export function storeCurrentSiteDetails(siteDetails) {
  storage.setExpires(SITE_STORAGE_KEY, siteDetails, 86400);
}

export function getCurrentSiteDetailsFromStorage() {
  return storage.get(SITE_STORAGE_KEY);
};

export function fetchCurrentSiteDetailsFromApi() {
  return axios.get(ENTRYPOINT + '/site-details').then((response) => response.data);
}
